export default {
  name: 'Nombre',
  priceToBeAgreed: 'Sin precio',
  email: 'Correo electrónico',
  password: 'Contraseña',
  whatsApp: 'WhatsApp',
  commission: 'Comisión',
  idNumber: 'Número',
  consumer: 'Consumidor',
  provider: 'Proveedor',
  views: 'Vistas',
  add: 'Agregar',
  create: 'Crear',
  downloadExcel: 'Descargar Excel',
  professionalServices: 'Servicios de profesionales',
  allServicesTypes: 'Servicios Todoservy',
  edit: 'Editar',
  delete: 'Eliminar',
  price: 'Precio',
  created: 'Creado',
  updated: 'Actualizado',
  status: 'Estado',
  title: 'Título',
  date: 'Fecha',
  cancel: 'Cancelar',
  save: 'Guardar',
  apply: 'Aplicar',
  download: 'Descargar',
  from: 'De',
  to: 'a',
  pickDay: 'Elige un día',
  site: {
    name: 'ToDoServy',
    slogan: 'Comunidad De Profesionales'
  },
  pages: {
    dashboard: 'Tablero de instrumentos',
    payed: 'Listado de pagos',
    specialities: 'Especialidades',
    serviceTypes: 'Tipos de servicio',
    industries: 'Industrias de servicios',
    invoice: 'Factura',
    users: 'Clientes',
    hunters: 'Cazadores',
    providers: 'Proveedores de servicios',
    invoices: 'Generar facturas',
    coupons: 'Cupón de descuento',
    visibility: 'Visibilidad y Calificación Profesional'
  },
  auth: {
    logIn: 'Inicio de sesión',
    errors: {
      email: 'Por favor ingrese el correo electrónico',
      password: 'Por favor ingrese la contraseña'
    }
  },
  statistics: {
    totalSales: '<strong>Total</strong><br>Ventas',
    sessionsCanceled: '<strong>Sesiones </strong><br>cancelado',
    sessionsBooked: '<strong>Total</strong><br>Sesiones reservadas',
    sessionsConfirmed: '<strong>Sesiones </strong><br>confirmadas por los Clientes',
    providersProfileViews: '<strong>Proveedores de servicios</strong><br>vistas de perfil'
  },
  hunters: {
    title: 'Asesor',
    delegate: 'Delegar un asesor',
    select: 'Seleccione un asesor'
  },
  providers: {
    search: 'Buscar proveedores de servicios',
    signed: 'Registrado en',
    export: 'Exportar a Excel'
  },
  invoices: {
    export: 'Factura de exportación'
  },
  payed: {
    consumer: 'Consumidor',
    documentType: 'Tipo de documento',
    document: 'Documento',
    professional: 'Profesional',
    amount: 'Monto pagado',
    transactionDate: 'Fecha transacción',
    paymentType: 'Tipo de pago',
    service: 'Servicio',
    dateAndTime: 'Hora y fecha',
    transactionAmount: 'Valor transacción',
    payedWith: 'Pagado con',
    client: 'Cliente'
  },
  addIndustry: 'Agregar industria de servicios',
  editIndustry: 'Editar industria de servicios',
  deleteServiceIndustry: '¿Está seguro de que desea eliminar este sector de servicios?',
  deleteServiceTypes: '¿Está seguro de que desea eliminar este tipo de servicio?',
  deleteSpeciality: '¿Está seguro de que desea eliminar esta especialidad del Servicio?'
}
